import {BRAND} from '../brand.js';
import { ENGAGEMENT_CONFIG } from './config';
export function dailyGoalReward(xp: number, target: number, verified: boolean) {
  return verified && Number.isFinite(xp) && Number.isFinite(target) && target > 0 && xp >= target
    ? Math.ceil(target * ENGAGEMENT_CONFIG.stamps.dailyBonusRate) : 0;
}
export function stampDay(xp: number, target: number, fullWeek = false) {
  if (!Number.isFinite(xp) || !Number.isFinite(target) || xp < 0 || target <= 0) return { base: 0, goal: 0, week: 0, total: 0 };
  const cap = target * ENGAGEMENT_CONFIG.stamps.dailyCapMultiplier;
  const base = Math.min(cap, xp * ENGAGEMENT_CONFIG.stamps.perMathXp);
  const goal = Math.min(cap - base, dailyGoalReward(xp, target, true));
  const earned = base + goal;
  const week = fullWeek ? Math.min(cap - earned, earned * ENGAGEMENT_CONFIG.stamps.weekBonusRate) : 0;
  return { base, goal, week, total: earned + week };
}
export function fullWeekEligible(days: readonly { scheduled: boolean; xp: number; target: number }[], closed: boolean) {
  return closed && days.length === 7 && days.some(day => day.scheduled) && days.every(day => !day.scheduled || (day.target > 0 && day.xp >= day.target));
}
export function suggestedTierPrice(target: number, tier: number) {
  if (!Number.isFinite(target) || target <= 0 || !Number.isInteger(tier) || tier < 1 || tier > 4) throw new Error('A positive XP target and tier 1–4 are required.');
  return Math.ceil(target * ENGAGEMENT_CONFIG.stamps.tierGoalDays[(tier - 1) as 0 | 1 | 2 | 3]);
}
// The Stamps rules as short items, for a list. stampRules joins them into one paragraph.
export function stampRuleList(currency: string = BRAND.currency): string[] {
  const rules = ENGAGEMENT_CONFIG.stamps;
  return [
    `Earn ${currency} at ${rules.perMathXp} per Math XP, based on the estimated minutes for real attempts.`,
    'Right and wrong attempts use the same XP rate; waiting earns nothing.',
    `Reach your daily target for a ${rules.dailyBonusRate * 100}% finishing bonus, rounded up, once per day.`,
    `Meet every scheduled day’s goal for a ${rules.weekBonusRate * 100}% bonus on that week’s earned Stamps.`,
    'Days off are neutral.',
    `Automatic Stamps stop at ${rules.dailyCapMultiplier} times your daily target each day; XP and learning keep counting.`,
    'Correctness and mastery do not pay Stamps.',
    'A parent can optionally add a bonus with a note.',
  ];
}
export function stampRules(currency: string = BRAND.currency) {
  return stampRuleList(currency).join(' ');
}
export const EXPERIENCE_PRIZES = ['Pick Friday dinner', 'Choose the weekend movie', 'A one-on-one outing with a parent', '30 extra minutes before bed'] as const;
